import React from 'react';
import {
  Button,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverHeader,
  VStack,
  Text,
  Badge,
  Box,
} from '@chakra-ui/react';
import { Bell } from 'phosphor-react';
import { IEventoAlerta } from '../../../hooks/useEventos';

const TIPO_COLORS: Record<string, string> = {
  assinatura_pendente: 'orange',
  nf_pendente: 'red',
  pagamento_pendente: 'yellow',
};

interface AlertasDropdownProps {
  alertas: IEventoAlerta[];
  // eslint-disable-next-line no-unused-vars
  onSelectEvento: (eventoId: number) => void;
}

export default function AlertasDropdown({ alertas, onSelectEvento }: AlertasDropdownProps) {
  if (alertas.length === 0) return null;

  return (
    <Popover placement="bottom-end">
      <PopoverTrigger>
        <Button size="sm" variant="outline" colorScheme="red" position="relative">
          <Bell size={16} />
          <Badge
            colorScheme="red"
            borderRadius="full"
            position="absolute"
            top="-1"
            right="-1"
            fontSize="2xs"
          >
            {alertas.length}
          </Badge>
        </Button>
      </PopoverTrigger>
      <PopoverContent w="320px">
        <PopoverHeader fontWeight="600" fontSize="sm">
          {alertas.length} alerta(s)
        </PopoverHeader>
        <PopoverBody maxH="300px" overflowY="auto" p={2}>
          <VStack spacing={1} align="stretch">
            {alertas.map(alerta => (
              <Box
                key={`${alerta.evento_id}-${alerta.tipo}-${alerta.contrato_id ?? ''}`}
                p={2}
                borderRadius="md"
                cursor="pointer"
                _hover={{ bg: 'gray.50' }}
                onClick={() => onSelectEvento(alerta.evento_id)}
                borderLeft="3px solid"
                borderLeftColor={`${TIPO_COLORS[alerta.tipo] || 'gray'}.400`}
              >
                <Text fontSize="xs" fontWeight="600" color="gray.700">
                  {alerta.descricao}
                </Text>
                <Text fontSize="2xs" color="gray.400">
                  {alerta.evento_nome}
                </Text>
              </Box>
            ))}
          </VStack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
